// Home.jsx
import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import Hero from '../screen/hero'; 
import Program from '../screen/program'; 
import '../allcss/home.css';
import kid1 from '../Asets/kid1.jpg';
import kid2 from '../Asets/kid2.jpg';
import kid3 from '../Asets/kid3.jpg';
import founder from '../Asets/meeta_gupta.jpeg';
import Facility from '../screen/facility';
import Appoitment from '../screen/appoitment';
import Footer from '../components/footer';
import Imagecard from '../screen/imagecard';
import Imageeffect from '../screen/imageeffect';
import ImageGallery from '../components/ImageGallery';
import { useLocation } from 'react-router-dom';
import RedPhoto1 from '../Asets/RedPhoto1.jpeg';
import RedPhoto2 from '../Asets/RedPhoto2.jpeg';
import RedPhoto3 from '../Asets/RedPhoto3.jpeg';
import RedPhoto4 from '../Asets/RedPhoto4.jpeg';
import RedPhoto5 from '../Asets/RedPhoto5.jpeg';
import RedPhoto6 from '../Asets/RedPhoto6.jpeg';
import gallery2 from '../Asets/gallery2.jpg';
import gallery3 from '../Asets/gallery3.jpg';
import gallery4 from '../Asets/gallery4.jpg';
import Head from '../screen/Head';
import FloatingContactPanel from '../screen/FloatingButtons'; 
import VideoPopup from './Video_Pop';

export default function Home() {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = location.hash;
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          setTimeout(() => {
            const delayedElement = document.getElementById(id);
            if (delayedElement) {
              delayedElement.scrollIntoView({ behavior: 'smooth' });
            }
          }, 300);
        }
      }
    };

    scrollToHash();
  }, [location]);

  const galleryImages = [
    { src: RedPhoto1, alt: 'Kids playing', title: 'Learning Through Play ' },
    { src: RedPhoto2, alt: 'Learning session', title: 'Happy School Moments ' },
    { src: RedPhoto3, alt: 'Group activity', title: 'Group Learning Activities ' },
    { src: RedPhoto4, alt: 'Outdoor play', title: 'Outdoor Fun Time ' },
    { src: RedPhoto5, alt: 'Story time', title: 'Storytelling Sessions ' },
    { src: RedPhoto6, alt: 'Art and craft', title: 'Creative Craft Activities ' },
    { src: gallery2, alt: 'Gallery Image 2', title: 'Our School Campus ' },
    { src: gallery3, alt: 'Gallery Image 3', title: 'Activity-Based Classroom ' },
    { src: gallery4, alt: 'Gallery Image 4', title: 'Child-Friendly Learning ' },
  ];

  return (
    <div>
      {showPopup && <VideoPopup onClose={() => setShowPopup(false)} />}
      <Header />
      <FloatingContactPanel />

      <section id="home">
        <Hero />
      </section>

      <section id="about" className="home-culture-section">
        <div className="home-container">
          
          {/* Text Section */}
          <div className="home-content">
            <h2>
             
Where Every Child Learns, Grows & Thrives
          </h2>
         <p>
  At <strong>RedSchoolhouse in Vadodara</strong>,we provide a joyful, safe, and nurturing environment where children learn through play, creativity, and hands-on experiences. Our Singapore-inspired curriculum, experienced educators, and personalized attention help every child build confidence, curiosity, and essential skills for lifelong learning.

</p>


            {/* Owner Section */}
            <div className="home-author-wrapper">
              <img src={founder} alt="Founder" className="home-author-photo" />
              <div className="home-author-text">
                <h4>Meeta Gupta</h4>
                <span>Head of School</span>
              </div>
            </div>
          </div>

          {/* Kids Image Section */}
          <div className="home-image-wrapper">
            <div className="home-circle home-main-img">
              <img src={kid1} alt="Kid 1" />
            </div>
            <div className="home-circle home-left-img">
              <img src={kid2} alt="Kid 2" />
            </div>
            <div className="home-circle home-right-img">
              <img src={kid3} alt="Kid 3" />
            </div>
          </div>
        </div>
      </section>

      <section id="programs">
        <Program />
      </section>
      <Imagecard />
      <Imageeffect />
      <Head />

      <section id="gallery" style={{ padding: '50px 20px', backgroundColor: '#fcfcfc' }}>
        <h2>Explore Life at RED School House </h2>
        <ImageGallery images={galleryImages} />
      </section>

      <section id="admissions">
        <Facility />
      </section>
      <section id="contact">
        <Appoitment />
      </section>

      <Footer />
    </div>
  );
}
